import React, { useEffect, useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { Page, Drawer } from '../../components';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { setLoading } from '../../store/portal/portalActions';
import { MyFavoriteModel } from '../../types';
import { EventCard } from '../../components/events/EventCard';
import { LoginForm } from '../../components/Auth';
import { fetchAllMyFavorites } from '../../store/myFavorites/myFavoritesActions';
import { validateLogon } from '../../utils/auth';

export const MyFavorites = ({ navigation }: any) => {
  const dispatch = useAppDispatch();
  const [rtPortal, rtUser, rtMyFav] = useAppSelector(s => [s.portal, s.user, s.myFavorites]);

  const [width, setWidth] = useState<number>(0);
  const [showLogin, setShowLogin] = useState<boolean>(false);

  useEffect(() => {
    console.log('in my fav');
    (async () => {
      if (!(await validateLogon(rtUser))) {
        navigation.navigate('login');
        //setShowLogin(true);
      } else {
        if (!rtMyFav.loaded) {
          fetchData();
        }
      }
    })();

    return () => {
      console.log('unmount my fav');
    };
  }, []);

  useEffect(() => {
    (async () => {
      if (await validateLogon(rtUser)) {
        fetchData();
      }
    })();
  }, [rtUser]);

  useEffect(() => {
    if (rtMyFav.loaded) dispatch(setLoading(false, 'MyFav'));
  }, [rtMyFav]);

  useEffect(() => {
    if (rtPortal.isSmallScreen) {
      setWidth(rtPortal.width - 2 * 16);
    } else {
      if (['md', 'lg'].includes(rtPortal.breakpoint)) {
        setWidth(rtPortal.width - 2 * 8);
      } else {
        setWidth(rtPortal.width - 2 * 8);
      }
    }
  }, [rtPortal.width]);

  const fetchData = () => {
    if (!rtMyFav.loaded) {
      dispatch(setLoading(true, 'MyFav - Fetch'));
      // Setting up data
      // Get master event data from API
      dispatch(
        fetchAllMyFavorites({
          limit: 30,
          searchParam: {},
          countToGet: 5,
        }),
      );
    }
  };

  return (
    <Page title={'My Favorites'}>
      <View style={[rtPortal.isSmallScreen ? homeStyle.containerSm : homeStyle.containerMd, { width: width }]}>
        {rtMyFav.allEvents.map((event: MyFavoriteModel, i: number) => {
          return <EventCard key={i} event={event.event} />;
        })}
      </View>
      <Drawer id="myfav.login" visible={showLogin} type="custom" onClose={() => null}>
        <LoginForm onClose={() => setShowLogin(false)} navigation={navigation} />
      </Drawer>
    </Page>
  );
};

const homeStyle = StyleSheet.create({
  containerMd: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginHorizontal: -8,
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  containerSm: {
    flex: 1,
    flexDirection: 'column',
    marginHorizontal: -8,
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
});
